export const cMetodoPago = {
    efectivo: 1,
    tarjeta: 2,
    cheque: 3,
    transferencia: 4
}